import React, { useEffect, useState } from 'react'
import { API_URL, getCookie, getHeaders } from '../helper/commonApi';
import axios from "axios";
import { useBranding } from '../context/BrandingContext';
import toast from 'react-hot-toast';
import Loader from '../components/loader';
import { useNavigate } from 'react-router-dom';

const TestQuestionComponents = () => {
    const { colors } = useBranding();
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [activeTab, setActiveTab] = useState("");

    const [question, setQuestion] = useState([]);

    const [isQuestionLoading, setIsQuestionLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const [essayAnswer, setEssayAnswer] = useState("");
    const [inputAnswer, setInputAnswer] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);

    const [manualQuestionId, setManualQuestionId] = useState("");
    const [manualLoading, setManualLoading] = useState(false);


    const userId = localStorage.getItem('_register_GRE_LOGIN_userId');

    const fetchQuestionById = async () => {
        if (!manualQuestionId.trim()) {
            toast.error("Please enter a Question ID");
            return;
        }

        setManualLoading(true);
        setIsQuestionLoading(true);
        try {
            const res = await axios.post(
                `${API_URL}/get-question-by-id`,
                { question_id: manualQuestionId.trim() },
                { headers: getHeaders() }
            );

            if (res.status === 200 && res?.data?.data?.question) {
                setQuestion(res.data.data.question);  // replace existing question
                setSelectedOptions([]);
                setInputAnswer("");
                setEssayAnswer("");
                // setManualQuestionId("")
                toast.success("Question Loaded!");
            } else {
                toast.error("Question not found");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Error fetching question");
        } finally {
            setManualLoading(false);
            setIsQuestionLoading(false);
        }
    };


    useEffect(() => {
        const jwtToken = getCookie('_GRE_JWT_TOKEN');

        if (!userId || !jwtToken) {
            localStorage.clear();
            document.cookie = "_GRE_JWT_TOKEN=; max-age=0; path=/;";
            navigate('/')
            return;
        }

        fetchCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const res = await axios.post(
                `${API_URL}/get-test-categories`, {},
                { headers: getHeaders() }
            );

            if (res.status === 200) {
                setCategories(res.data.data.categories || []);


                if (res.data.data.categories.length > 0) {
                    const firstCategory = res.data.data.categories[0].category;
                    setActiveTab(firstCategory);
                    fetchQuestions(firstCategory); // load first tab questions
                }
                setLoading(false);

            }
        } catch (error) {
            console.error("Error fetching test results:", error);
            setLoading(false);
        }
    };

    const fetchQuestions = async (category) => {
        setIsQuestionLoading(true);
        setQuestion([]);
        try {
            const res = await axios.post(
                `${API_URL}/get-test-question`,
                { category },
                { headers: getHeaders() }
            );

            if (res.status === 200) {
                setQuestion(res.data.data.question || []);
                setIsQuestionLoading(false);
            }
        } catch (error) {
            console.error("Error fetching questions:", error);
        } finally {
            setIsQuestionLoading(false);
        }
    };

    const handleSubmitQuestion = async () => {
        setIsQuestionLoading(true);
        try {
            const answer =
                question?.input_field?.toLowerCase() === "textarea"
                    ? essayAnswer
                    : question?.input_field?.toLowerCase() === "input"
                        ? inputAnswer
                        : selectedOptions.sort().join(",");

            const res = await axios.post(
                `${API_URL}/submit-test-answer`,
                {
                    question_id: question?.id,
                    answer,
                    category: activeTab,
                },
                { headers: getHeaders() }
            );

            if (res.status === 200) {

                setIsQuestionLoading(false);

                if (!res?.data?.status) {
                    toast.error(res?.data?.message || "Error submitting question");
                    return
                }

                fetchQuestions(activeTab);
                // toast.success(res.data.message || "Answer submitted successfully");

                setInputAnswer("");
                setSelectedOptions([]);
            }

        }
        catch (err) {
            console.error("Error submitting question:", err);
            setIsQuestionLoading(false);
        }
    };


    /* ---------------- Skeleton Loader ---------------- */
    const SkeletonBlock = ({ height }) => (
        <span
            style={{
                display: "block",
                height,
                background: "#e0e0e0",
                borderRadius: "4px",
                marginBottom: "10px",
                animation: "pulse 1.5s infinite",
            }}
        ></span>
    );

    /* ---------------- Options (Single / Multi) ---------------- */
    const OptionsField = ({
        options,
        question,
        selectedOptions,
        setSelectedOptions,
        loading,
    }) => {
        if (loading) {
            return (
                <div className="options">
                    {[...Array(5)].map((_, idx) => (
                        <SkeletonBlock key={idx} height="40px" />
                    ))}
                </div>
            );
        }

        return (
            <div className="options">
                {options.map((opt, idx) => {
                    const optionLetter = String.fromCharCode(65 + idx);
                    const isSelected = selectedOptions.includes(optionLetter);
                    const isImage = typeof opt === "string" && opt.startsWith("http");

                    const handleOptionClick = () => {
                        if (question?.input_field?.toLowerCase() === "single") {
                            // allow only one
                            setSelectedOptions([optionLetter]);
                        } else if (question?.input_field?.toLowerCase() === "multi") {
                            // allow multiple
                            if (isSelected) {
                                setSelectedOptions(selectedOptions.filter((o) => o !== optionLetter));
                            } else {
                                setSelectedOptions([...selectedOptions, optionLetter]);
                            }
                        }
                    };

                    return (
                        <label
                            key={idx}
                            className={`option ${isSelected ? "selected" : ""}`}
                        >
                            <input
                                type={question?.input_field?.toLowerCase() === "single" ? "radio" : "checkbox"}
                                name={`question-${question?.id}`}
                                id={`question-${question?.id}`}
                                checked={isSelected}
                                onChange={handleOptionClick}
                                className="cursor-pointer"
                            />
                            <strong>{optionLetter}.</strong>
                            {isImage ? (
                                <img
                                    src={opt}
                                    alt={`Option ${optionLetter}`}
                                    style={{ height: "28px", objectFit: "contain" }}
                                />
                            ) : (
                                <span>{opt}</span>
                            )}
                        </label>
                    );
                })}

                {/* <p className="instruction">
                    Select {question?.input_field?.toLowerCase() === "single" ? "One" : "Multiple"} Answer
                    Choice.
                </p> */}
            </div>
        );
    };


    const cleanQuotes = (str) => {
        if (!str) return str;

        return str
            // PDF, OCR, Windows-1252 control quotes
            // eslint-disable-next-line no-control-regex
            .replace(/[\u0000-\u001F]/g, "")   // remove invisible control junk

            // Replace ALL curly/smart quotes with normal ones
            .replace(/[“”«»„‟]/g, '"')         // double quotes
            .replace(/[‘’‚‛]/g, "'")           // single quotes

            // Replace full-width quotes (from OCR)
            .replace(/[\uFF02\uFF07]/g, '"');
    };


    // Build options safely
    const options = [
        question?.choiceA,
        question?.choiceB,
        question?.choiceC,
        question?.choiceD,
        question?.choiceE,
        question?.choiceF,
        question?.choiceG,
        question?.choiceH,
        question?.choiceI,
        question?.choiceJ,
    ].filter(Boolean);


    return (
        <>
            {loading ? <Loader /> :
                <div style={{ margin: "20px" }} >
                    <div className='container main-border bg-white' style={{ padding: "20px" }}>

                        {/* Tabs */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {categories.map((cat) => (
                                <button
                                    key={cat.category}
                                    onClick={() => {
                                        setActiveTab(cat.category);
                                        fetchQuestions(cat.category);
                                        setManualQuestionId("")
                                    }}
                                    className={`sidebar-tab  ${activeTab === cat.category ? "active" : ""
                                        }`}
                                    style={{
                                        padding: "12px",
                                        margin: "4px 0",
                                        width: "110px",
                                        background:
                                            activeTab === cat.category ? colors.primaryColor : "#f5f5f5",
                                        color: activeTab === cat.category ? "#fff" : "#333",
                                        fontWeight: activeTab === cat.category ? 600 : 400,
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    {cat.category}
                                </button>
                            ))}
                        </div>

                        {/* ======================================= */}

                        {/* Manual Question Search */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                margin: "20px 0",
                                background: "#f5f5f5",
                                padding: "12px",
                                borderRadius: "6px",
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Enter Question ID (e.g., GREQVBL0000)"
                                value={manualQuestionId}
                                onChange={(e) => setManualQuestionId(e.target.value)}
                                style={{
                                    flex: 1,
                                    padding: "10px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                }}
                            />

                            <button
                                onClick={fetchQuestionById}
                                disabled={manualLoading}
                                style={{
                                    padding: "10px 18px",
                                    background: colors.buttonBg,
                                    color: colors.buttonText,
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    opacity: manualLoading ? 0.6 : 1,
                                }}
                            >
                                {manualLoading ? "Loading..." : "Show Question"}
                            </button>
                        </div>


                        {/* ========================================= */}

                        {/* ----  Question  ----  */}
                        <div className="question-block">
                            {/* <div style={{ marginBottom: "12px" }}>
                                {isQuestionLoading ?
                                    <span
                                        style={{
                                            display: "block",
                                            width: "200px",
                                            height: "22px",
                                            background: "#e0e0e0",
                                            borderRadius: "4px",
                                            marginBottom: "10px",
                                            animation: "pulse 1.5s infinite",
                                        }}
                                    ></span> :
                                    <strong>ID : {question?.question_id}</strong>
                                }
                            </div> */}


                            {/* question Title */}
                            <p className="question-text">
                                {isQuestionLoading ? (
                                    <span
                                        style={{
                                            display: "block",
                                            height: "22px",
                                            background: "#e0e0e0",
                                            borderRadius: "4px",
                                            marginBottom: "10px",
                                            animation: "pulse 1.5s infinite",
                                        }}
                                    ></span>
                                ) : (
                                    // <>
                                    //     {(() => {
                                    //         const parts = ["part1", "part2", "part3", "part4"]
                                    //             .map((key) => question?.[key])
                                    //             .filter(Boolean);

                                    //         // Check if we have both Quantity A and Quantity B
                                    //         const qtyA = parts.find((p) => p.startsWith("Quantity A"));
                                    //         const qtyB = parts.find((p) => p.startsWith("Quantity B"));

                                    //         return parts.map((part, idx) => {
                                    //             // Render Quantity A + B together side by side
                                    //             if (part === qtyA && qtyB) {
                                    //                 return (
                                    //                     <div
                                    //                         key="quantity-ab"
                                    //                         style={{
                                    //                             display: "grid",
                                    //                             gridTemplateColumns: "1fr 1fr",
                                    //                             gap: "40px",
                                    //                             margin: "16px 0",
                                    //                             textAlign: "center",
                                    //                         }}
                                    //                     >
                                    //                         {/* Quantity A */}
                                    //                         {/* <div>
                                    //                             <div style={{ fontWeight: "600", marginBottom: "6px" }}>
                                    //                                 Quantity A
                                    //                             </div>
                                    //                             <div>{qtyA.split("|$|")[1]}</div>
                                    //                         </div> */}
                                    //                         <div>
                                    //                             <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                                    //                                 Quantity A
                                    //                             </div>
                                    //                             {qtyA.split("|$|")
                                    //                                 .slice(1) // skip "Quantity A" label
                                    //                                 .map((line, idx) =>
                                    //                                     line.startsWith("http") ? (
                                    //                                         <img
                                    //                                             key={idx}
                                    //                                             src={line}
                                    //                                             alt={`qtyA-${idx}`}
                                    //                                             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                    //                                         />
                                    //                                     ) : (
                                    //                                         <div key={idx} style={{ marginBottom: "6px" }}>
                                    //                                             {line}
                                    //                                         </div>
                                    //                                     )
                                    //                                 )}
                                    //                         </div>

                                    //                         {/* Quantity B */}
                                    //                         {/* <div>
                                    //                             <div style={{ fontWeight: "600", marginBottom: "6px" }}>
                                    //                                 Quantity B
                                    //                             </div>
                                    //                             <div>{qtyB.split("|$|")[1]}</div>
                                    //                         </div> */}
                                    //                         <div>
                                    //                             <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                                    //                                 Quantity B
                                    //                             </div>
                                    //                             {qtyB.split("|$|")
                                    //                                 .slice(1) // skip "Quantity B" label
                                    //                                 .map((line, idx) =>
                                    //                                     line.startsWith("http") ? (
                                    //                                         <img
                                    //                                             key={idx}
                                    //                                             src={line}
                                    //                                             alt={`qtyB-${idx}`}
                                    //                                             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                    //                                         />
                                    //                                     ) : (
                                    //                                         <div key={idx} style={{ marginBottom: "6px" }}>
                                    //                                             {line}
                                    //                                         </div>
                                    //                                     )
                                    //                                 )}
                                    //                         </div>
                                    //                     </div>
                                    //                 );
                                    //             }

                                    //             // Skip rendering qtyB separately (already shown with A)
                                    //             if (part === qtyB) return null;

                                    //             // Default rendering (for part1, part4, etc.)
                                    //             return (
                                    //                 <div key={idx} style={{ marginBottom: "12px" }}>
                                    //                     {part.split("|$|").map((line, lineIdx) => {
                                    //                         const isImage = line.startsWith("http");
                                    //                         return isImage ? (
                                    //                             <img
                                    //                                 key={lineIdx}
                                    //                                 src={line}
                                    //                                 alt={`part-${idx}-${lineIdx}`}
                                    //                                 style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                    //                             />
                                    //                         ) : (
                                    //                             <div key={lineIdx} style={{ marginBottom: "6px" }}>
                                    //                                 {line}
                                    //                             </div>
                                    //                         );
                                    //                     })}
                                    //                 </div>
                                    //             );
                                    //         });
                                    //     })()}
                                    // </>



                                    // <>
                                    //     {(() => {
                                    //         const parts = ["part1", "part2", "part3", "part4"]
                                    //             .map((key) => question?.[key])
                                    //             .filter(Boolean);

                                    //         // 🔹 Identify possible label pairs (you can add more here if needed)
                                    //         const PAIRS = [
                                    //             ["Quantity A", "Quantity B"],
                                    //             ["Column A", "Column B"],
                                    //         ];

                                    //         // 🔹 Helper: render text or image
                                    //         // const renderLine = (line, key) =>
                                    //         //     line.startsWith("http") ? (
                                    //         //         <img
                                    //         //             key={key}
                                    //         //             src={line}
                                    //         //             alt={`line-${key}`}
                                    //         //             style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                    //         //         />
                                    //         //     ) : (
                                    //         //         <div key={key} style={{ marginBottom: "6px" }}>
                                    //         //             {line}
                                    //         //         </div>
                                    //         //     );

                                    //         const renderLine = (line, key) => {
                                    //             const trimmed = line.trim();
                                    //             const text = cleanQuotes(trimmed);

                                    //             return text.startsWith("http") ? (
                                    //                 <img
                                    //                     key={key}
                                    //                     src={text}
                                    //                     alt={`line-${key}`}
                                    //                     style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                    //                 />
                                    //             ) : (
                                    //                 <div key={key} style={{ marginBottom: "6px" }}>
                                    //                     {text}
                                    //                 </div>
                                    //             );
                                    //         }

                                    //         // 🔹 Helper: render one box (A or B)
                                    //         const renderBox = (label, value, key) => (
                                    //             <div key={key}>
                                    //                 <div style={{ fontWeight: "600", marginBottom: "8px" }}>{label}</div>
                                    //                 {value
                                    //                     .split("|$|")
                                    //                     .slice(1)
                                    //                     .map((line, idx) => renderLine(line, `${label}-${idx}`))}
                                    //             </div>
                                    //         );

                                    //         return parts.map((part, idx) => {
                                    //             // check if this part belongs to any pair (e.g. Quantity A & B or Column A & B)
                                    //             // const pair = PAIRS.find(([a, b]) =>
                                    //             //     part.startsWith(a) || part.startsWith(b)
                                    //             // );

                                    //             const pair = PAIRS.find(([a, b]) => {
                                    //                 // VALID ONLY IF contains |$|
                                    //                 if (!part.includes("|$|")) return false;

                                    //                 const label = part.split("|$|")[0];
                                    //                 return label === a || label === b;
                                    //             });

                                    //             if (pair) {
                                    //                 const [labelA, labelB] = pair;
                                    //                 const partA = parts.find((p) => p.startsWith(labelA));
                                    //                 const partB = parts.find((p) => p.startsWith(labelB));

                                    //                 // only render once (when we hit A)
                                    //                 if (part === partA && partB) {
                                    //                     return (
                                    //                         <div
                                    //                             key={`${labelA}-${labelB}`}
                                    //                             style={{
                                    //                                 display: "grid",
                                    //                                 gridTemplateColumns: "1fr 1fr",
                                    //                                 gap: "40px",
                                    //                                 margin: "16px 0",
                                    //                                 textAlign: "center",
                                    //                             }}
                                    //                         >
                                    //                             {renderBox(labelA, partA, "A")}
                                    //                             {renderBox(labelB, partB, "B")}
                                    //                         </div>
                                    //                     );
                                    //                 }

                                    //                 // Skip rendering the second one (B) separately
                                    //                 if (part === partB) return null;
                                    //             }

                                    //             // 🔹 Default rendering (for everything else)
                                    //             return (
                                    //                 <div key={idx} style={{ marginBottom: "12px" }}>
                                    //                     {part.split("|$|").map((line, lineIdx) =>
                                    //                         renderLine(line, `part-${idx}-${lineIdx}`)
                                    //                     )}
                                    //                 </div>
                                    //             );
                                    //         });
                                    //     })()}
                                    // </>
                                    <>
                                        {(() => {
                                            const parts = ["part1", "part2", "part3", "part4"]
                                                .map((key) => question?.[key])
                                                .filter(Boolean);

                                            // Possible label pairs
                                            const PAIRS = [
                                                ["Quantity A", "Quantity B"],
                                                ["Column A", "Column B"],
                                            ];

                                            // Fix Unicode look-alike characters (Cyrillic A, B, etc.)
                                            const normalize = (str = "") =>
                                                cleanQuotes(str)
                                                    .trim()
                                                    .replace(/А/g, "A") // Cyrillic A → Latin A
                                                    .replace(/В/g, "B") // Cyrillic Ve → Latin B
                                                    .replace(/\s+/g, " ");

                                            const renderLine = (line, key) => {
                                                const text = normalize(line.trim());

                                                return text.startsWith("http") ? (
                                                    <img
                                                        key={key}
                                                        src={text}
                                                        alt={`line-${key}`}
                                                        style={{ maxWidth: "100%", height: "auto", marginBottom: "6px" }}
                                                    />
                                                ) : (
                                                    <div key={key} style={{ marginBottom: "6px" }}>
                                                        {text}
                                                    </div>
                                                );
                                            };

                                            const renderBox = (label, value, key) => (
                                                <div key={key}>
                                                    <div style={{ fontWeight: "600", marginBottom: "8px" }}>{label}</div>
                                                    {value
                                                        .split("|$|")
                                                        .slice(1)
                                                        .map((line, idx) => renderLine(line, `${label}-${idx}`))}
                                                </div>
                                            );

                                            return parts.map((originalPart, idx) => {
                                                const normalizedPart = normalize(originalPart);

                                                // -------- Detect which pair this part belongs to --------
                                                const pair = PAIRS.find(([a, b]) => {
                                                    if (!normalizedPart.includes("|$|")) return false;

                                                    const label = normalize(normalizedPart.split("|$|")[0]);
                                                    return label === normalize(a) || label === normalize(b);
                                                });

                                                if (pair) {
                                                    const [labelA, labelB] = pair;

                                                    // -------- Find actual parts for A and B --------
                                                    const partA = parts.find(
                                                        (p) => normalize(p.split("|$|")[0]) === normalize(labelA)
                                                    );

                                                    const partB = parts.find(
                                                        (p) => normalize(p.split("|$|")[0]) === normalize(labelB)
                                                    );

                                                    console.log("Paired parts resolved:", { partA, partB });

                                                    // Render only when encountering A (avoid double rendering)
                                                    if (originalPart === partA && partB) {
                                                        return (
                                                            <div
                                                                key={`${labelA}-${labelB}`}
                                                                style={{
                                                                    display: "grid",
                                                                    gridTemplateColumns: "1fr 1fr",
                                                                    gap: "40px",
                                                                    margin: "16px 0",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {renderBox(labelA, partA, "A")}
                                                                {renderBox(labelB, partB, "B")}
                                                            </div>
                                                        );
                                                    }

                                                    // Skip rendering B separately
                                                    if (originalPart === partB) return null;
                                                }

                                                // -------- Default rendering (non-paired parts) --------
                                                return (
                                                    <div key={idx} style={{ marginBottom: "12px" }}>
                                                        {originalPart
                                                            .split("|$|")
                                                            .map((line, lineIdx) =>
                                                                renderLine(line, `part-${idx}-${lineIdx}`)
                                                            )}
                                                    </div>
                                                );
                                            });
                                        })()}
                                    </>

                                )}
                            </p>

                            {!isQuestionLoading && (question?.input_field?.toLowerCase() === "single" || question?.input_field?.toLowerCase() === "multi") &&
                                <p className="instruction">Select {question?.input_field?.toLowerCase() === "single" ? "One" : "Multi"} Answer Choice.</p>
                            }

                            {/* answer field Type */}
                            {question?.input_field?.toLowerCase() === "textarea" ? (
                                isQuestionLoading ? (
                                    <SkeletonBlock height="200px" />
                                ) : (
                                    <textarea
                                        // value={essayAnswer}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setEssayAnswer(value);
                                        }}
                                        placeholder="Write your essay here..."
                                        style={{ width: "100%", padding: "20px" }}
                                        rows={10}
                                    />
                                )
                            ) : question?.input_field?.toLowerCase() === "input" ? (
                                isQuestionLoading ? (
                                    <SkeletonBlock height="40px" />
                                ) : (
                                    <input
                                        id="inputAnswer"
                                        name="inputAnswer"
                                        type="text"
                                        value={inputAnswer}
                                        onChange={(e) => setInputAnswer(e.target.value)}
                                        placeholder="Enter your answer"
                                        style={{
                                            width: "100%",
                                            padding: "12px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                )
                            ) : (
                                <OptionsField
                                    options={options}
                                    question={question}
                                    selectedOptions={selectedOptions}
                                    setSelectedOptions={setSelectedOptions}
                                    loading={isQuestionLoading}
                                />
                            )}
                        </div>

                        <div style={{ textAlign: "center" }}>
                            <button
                                className="footer-button"
                                style={{
                                    background: colors?.buttonBg, color: colors?.buttonText,
                                }}
                                onClick={handleSubmitQuestion}
                            >
                                Next
                            </button>
                        </div>

                    </div>
                </div>
            }
        </>
    )
}

export default TestQuestionComponents